
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

interface ClearAddressButtonProps {
  onClear: () => void;
}

export const ClearAddressButton = ({ onClear }: ClearAddressButtonProps) => {
  const isMobile = useIsMobile();
  
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onClear}
    >
      <X className="h-4 w-4 mr-2" />
      {isMobile ? "Clear" : "Clear address"}
    </Button>
  );
};
